import React from "react";
import { DatePicker, Form, Input, Select } from "antd";
import moment from "moment";
import { useSelector } from "react-redux";
import ImageComponent from "./useAttachments";
import { requiredFeilds, getErrorText } from "../utils";

const { Option } = Select;
const { TextArea } = Input;

const EditableCell = ({
  cell,
  expandedRowKeys,
  setExpandedRowKeys,
  images,
  setImages,
  attachPopupVisible,
  setAttachPopupVisible,
  currentUpdateObj,
  values,
  handleChangeDocType,
  getCloumnName,
  isRevisionUpdateCase,
  dueDateRequired,
}) => {
  const {
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  } = cell;
  const shouldDisabled = values?.document_template_id > 0 ? false : true;

  const { allTemplates } = useSelector((state) => state.docTypesReducer);
  const { allDocStatuses } = useSelector((state) => state.docStatusReducer);

  let inputNode;

  let classname = `${isRevisionUpdateCase ? "ims-doc-readonly-input" : ""}`;

  let isRequired = [...requiredFeilds];
  dueDateRequired && isRequired.push("document_due_date");

  switch (dataIndex) {
    case "document_date":
      inputNode = (
        <DatePicker
          format={"DD MMM YYYY"}
          size="large"
          style={{ minWidth: "120px" }}
          suffixIcon={null}
          allowClear={false}
          className={classname}
          disabled={isRevisionUpdateCase}
        />
      );
      break;
    case "username":
      inputNode = <Input readOnly className="border-less-input" />;
      break;
    case "document_template_id":
      inputNode = (
        <Select
          showSearch
          className={`activities-selector ${classname}`}
          getPopupContainer={() =>
            document.getElementsByClassName(
              "ant-layout-content layout-content site-layout-background custom-textarea"
            )[0]
          }
          dropdownClassName="select-dropdown-custom"
          placeholder="Select Doc Type"
          size="small"
          disabled={isRevisionUpdateCase}
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          onChange={(e) => {
            handleChangeDocType(e);
            let key = expandedRowKeys[0];
            setExpandedRowKeys([]);
            setExpandedRowKeys([key]);
          }}
        >
          {allTemplates.map(({ id, name }) => (
            <Option key={id} value={id}>
              {name}
            </Option>
          ))}
        </Select>
      );
      break;
    case "document_status_id":
      inputNode = (
        <Select
          showSearch
          disabled={shouldDisabled || isRevisionUpdateCase}
          className={`activities-selector ${classname}`}
          style={{ width: "120px" }}
          getPopupContainer={() =>
            document.getElementsByClassName(
              "ant-layout-content layout-content site-layout-background custom-textarea"
            )[0]
          }
          dropdownClassName="select-dropdown-custom"
          placeholder="Status"
          size="small"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {allDocStatuses.map(({ id, status_name }) => (
            <Option key={id} value={id}>
              {status_name}
            </Option>
          ))}
        </Select>
      );
      break;
    case "document_due_date":
      inputNode = (
        <DatePicker
          placeholder="Date"
          size="small"
          format={"D MMM YY"}
          style={{ minWidth: "90px" }}
          suffixIcon={null}
          allowClear={false}
          disabled={shouldDisabled || isRevisionUpdateCase}
          className={classname}
        />
      );
      break;
    case "document_number":
      inputNode = <Input readOnly className="border-less-input" />;
      break;
    case "sheets":
      inputNode = (
        <Input
          disabled={shouldDisabled || isRevisionUpdateCase}
          placeholder={getCloumnName(7)}
          size="large"
          classname={classname}
          readOnly={isRevisionUpdateCase}
        />
      );
      break;
    case "comment":
      inputNode = (
        <TextArea
          disabled={shouldDisabled || isRevisionUpdateCase}
          readOnly={isRevisionUpdateCase}
          rows={2}
          placeholder={getCloumnName(8)} // Insert Comment
          classname={classname}
        />
      );
      break;
    case "images":
      inputNode = (
        <ImageComponent
          images={images}
          setImages={setImages}
          attachPopupVisible={attachPopupVisible}
          setAttachPopupVisible={setAttachPopupVisible}
          currentUpdateObj={currentUpdateObj}
          shouldDisabled={shouldDisabled}
        />
      );
      break;
    default:
      break;
  }
  return (
    <td {...restProps}>
      {editing ? (
        dataIndex === "stop_time" ? (
          <Form.Item
            name={dataIndex}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: ``,
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  let startTime = getFieldValue("start_time");
                  const isBefore = moment(startTime).isBefore(
                    value,
                    "milliseconds"
                  );
                  if (isBefore) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(""));
                },
              }),
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          <Form.Item
            className={`ims-doc-first-level ${classname}`}
            name={dataIndex}
            style={{ margin: 0 }}
            rules={[
              {
                required: isRequired.includes(dataIndex),
                message: getErrorText(dataIndex),
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        )
      ) : (
        children
      )}
    </td>
  );
};

export default EditableCell;
